var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('reports.headers.alerts')))])],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.alert.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.alert.description)+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca037a42","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/extracurriculares/reports/show_alert.vue
// module id = o4gN
// module chunks = 2